import { envMode } from 'api';
import { usePostHog } from 'posthog-js/react';
import { useEffect, useRef } from 'react';
import useUserDetails from '../useUserDetails/useUserDetails';

const usePostHogIdentify = () => {
  const postHog = usePostHog();

  const { userId, email, phone, fullName, gender, age } = useUserDetails();

  const userIdentifiedRef = useRef(false);

  useEffect(() => {
    if (userId && !userIdentifiedRef.current) {
      postHog.identify(userId, {
        user_id: userId,
        email,
        phone,
        name: fullName,
        gender,
        age,
        environment: envMode,
        platform: 'web',
      });

      userIdentifiedRef.current = true;
    }

    return () => {
      userIdentifiedRef.current = false;
    };
  }, [email, fullName, gender, phone, postHog, userId, age]);
};

export default usePostHogIdentify;
